import { logout } from '@/services/loginController'
import { Dropdown, type MenuProps, message } from 'antd'
import webConfig from '@/constants/common-env'
import { LogoutOutlined, UserOutlined } from '@ant-design/icons'

export default function RightContent({initialState}){


    const handleLogout = async () => {
        try {
            // 调用退出登录接口
            await logout()
            message.success('退出登录成功')
            // 跳转到登录页面
            const currentUrl = window.location.href
            window.location.href = webConfig.loginUrl + '?redirectUrl=' + encodeURIComponent(currentUrl)
        } catch (error) {
            message.error('退出登录失败，请重试')
        }
    }

    const handleUserCenter = () => {
        // 在新标签页打开个人中心
        window.open(webConfig.userUrl, '_blank')
    }

    const handleLoginClick = () => {
        // 未登录，跳转到登录页面，并带上当前页面的 redirect 参数
        const currentUrl = window.location.href
        window.location.href = webConfig.loginUrl + '?redirectUrl=' + encodeURIComponent(currentUrl)
    }

    // 如果已登录，显示用户头像和下拉菜单
    if (initialState?.loginUser) {
        const menuItems: MenuProps['items'] = [
            {
                key: 'userCenter',
                icon: <UserOutlined />,
                label: '个人中心',
                onClick: handleUserCenter,
            },
            {
                type: 'divider',
            },
            {
                key: 'logout',
                icon: <LogoutOutlined />,
                label: '退出登录',
                onClick: handleLogout,
            },
        ]

        return (
            <Dropdown menu={{ items: menuItems }} placement="bottomRight">
                <div
                    style={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0 12px',
                    }}
                >
                    <UserOutlined style={{ fontSize: 16, color: '#2e2c28' }} />
                    <span style={{ marginLeft: 8, color: '#2e2c28' }}>
                                {initialState.loginUser.userName || '用户'}
                            </span>
                </div>
            </Dropdown>
        )
    }

    // 未登录，显示登录文字
    return (
        <div
            onClick={handleLoginClick}
            style={{
                cursor: 'pointer',
                color: '#2e2c28',
                fontSize: 14,
                padding: '0 12px',
                transition: 'color 0.3s',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.color = '#e97451'
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.color = '#2e2c28'
            }}
        >
            登录
        </div>
    )
}
